/* eslint-disable import/extensions */
import './styles.css'
import game from './game'

game()